import Home from "./pages/home/Home";
import Posts from "./pages/posts/Posts";

export const RoutesPage = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "*",
    element: <h1>404 Not Found</h1>,
  },
  {
    path: "/posts/:postId",
    element: <Posts />,
  },
];